import PropTypes from 'prop-types';

export const beginningBalancesPropType = PropTypes.shape({
  bookType: PropTypes.string.isRequired,
  chartName: PropTypes.string.isRequired,
  companyCode: PropTypes.string.isRequired,
  costCenter: PropTypes.string.isRequired,
  currencyCode: PropTypes.string.isRequired,
  geography: PropTypes.string.isRequired,
  importStatusDetail: PropTypes.number.isRequired,
  importValidation: PropTypes.string,
  localAccount: PropTypes.string.isRequired,
  localAccountDescription: PropTypes.string.isRequired,
  periodName: PropTypes.string.isRequired,
  productLine: PropTypes.string.isRequired,
  project: PropTypes.string.isRequired,
  r2rAccount: PropTypes.string.isRequired,
  r2rDescription: PropTypes.string.isRequired,
  reference: PropTypes.string.isRequired,
  tradingPartner: PropTypes.string.isRequired,
  trialBalanceDetailId: PropTypes.number.isRequired,
  ytdBalance: PropTypes.number.isRequired,
}).isRequired;

export const companyCodePropType = PropTypes.shape({
  companyCode: PropTypes.string.isRequired,
  statCalc: PropTypes.string.isRequired,
  source: PropTypes.string,
  functionalCurrency: PropTypes.string,
});

export const validationSummaryPropType = PropTypes.shape({
  chartName: PropTypes.string.isRequired,
  chartVersion: PropTypes.number.isRequired,
  fileName: PropTypes.string,
  importFileRowCount: PropTypes.number.isRequired,
  importResults: PropTypes.string.isRequired,
  importStatus: PropTypes.number.isRequired,
  trialTotal: PropTypes.number.isRequired,
});

const esCompanyDetailsPropType = PropTypes.shape({
  companyCode: PropTypes.string.isRequired,
  functionalCurrency: PropTypes.string.isRequired,
});

const nonEsCompanyDetailsPropType = PropTypes.shape({
  managementEntity: PropTypes.string.isRequired,
  legalEntity: PropTypes.string.isRequired,
  functionalCurrency: PropTypes.string.isRequired,
});

export const connectionTemplatesDetailsPropType = PropTypes.arrayOf(
  PropTypes.oneOfType([
    nonEsCompanyDetailsPropType,
    esCompanyDetailsPropType,
  ])
).isRequired;
